
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa364af026ce68435b1cb3a999bc233e3en from './en.yaml'
            i18n.addResourceBundle('en', 'a364af026ce68435b1cb3a999bc233e3', flattenObject(nsa364af026ce68435b1cb3a999bc233e3en), true, true);
        
        export default 'a364af026ce68435b1cb3a999bc233e3';
    